module.exports = __webpack_public_path__ + "img/V65.4b1756ad.jpg";